import { render, staticRenderFns } from "./CommonPatientPageHeader.vue?vue&type=template&id=af279420"
import script from "./CommonPatientPageHeader.vue?vue&type=script&lang=js"
export * from "./CommonPatientPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports